// removed by extract-text-webpack-plugin
module.exports = {"container":"_1o90MxXwDuTxG0o4foNEN4","expireView":"_1XHI0aE9DVh_6G1uFHos5W","expireText":"_2Octx7tI8s9o3_vyDHoXJg","imageContainer":"_3n1w5jVbpYyCe37AcvJdeG","verticalDashes":"hd8RKIanvRSTgVkTHNdKH","voucherInfoContainer":"_2GfJv4-oA8MP7s89Ia0ERx","voucherTitle":"_3cX0AzVQxb3-AB4_mXtLEf","priceView":"_2swZlUaTeNgoURRyHxeiod","priceInfo":"QKxQi_QD-OwqP8WGmWzaC","newPrice":"_3sLSheKhAxybDFJbZC8Dx2","oldPrice":"_1d0MZtk7mFH-9-b-EhSrLm","bookingBtn":"_2XETvI4lsP8H2UbUpFdFu9","userCode":"_27z_CWu3rALV51X2i24VZS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/MyVoucherItem.scss
// module id = 1155
// module chunks = 0